import * as fromBackMiscActions from './misc.actions';

export { BackMiscFeatureKey } from './misc.reducer';
export
{
    fromBackMiscActions as BackMiscMiscActions
};
